// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_br-0";
export var orangeButton = "_br-1";